import { render, staticRenderFns } from "./CriterioGetHighlightDates.vue?vue&type=template&id=f477f3f8"
import script from "./CriterioGetHighlightDates.vue?vue&type=script&lang=js"
export * from "./CriterioGetHighlightDates.vue?vue&type=script&lang=js"
import style0 from "./CriterioGetHighlightDates.vue?vue&type=style&index=0&id=f477f3f8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports